console.log("club-finder.js loaded");

var points = [];
var default_zoom = 15;
var markers = [];
var locations_map;
var user_location = {};

var map;

async function initMap(map_element)
{

    const { Map } = await google.maps.importLibrary("maps");

    var noPoi = [
        {
            featureType: "poi",
            stylers: [ { visibility: "off" } ]   
        }
        ];

    var zoomControlOptions = { position: google.maps.ControlPosition.RIGHT_CENTER };
    var streetViewControlOptions = { position: google.maps.ControlPosition.RIGHT_CENTER };

    locations_map = new Map(map_element,
    {
        zoom: default_zoom,
        mapTypeControl: false,
        zoomControl: true,
        zoomControlOptions: zoomControlOptions,
        streetViewControl: true,
        streetViewControlOptions: streetViewControlOptions,
        fullscreenControl: false,
        styles: noPoi
    });

    markers[map_element.id] = [];
    points[map_element.id] = [];

    addMapMarkers();

    return locations_map;
}

function addMarker(map,point,location_id,title,marker,marker_size="")
{
    var point = { lat: point[0], lng: point[1] };
    var map_id = map.getDiv().id;

    //title = $('<textarea />').html(title).text(); //remove any html entities like &amp; from the title

    points[map_id].push(point);

    if (marker_size == "large")
    {
        var size = new google.maps.Size(54, 61);
        var origin = new google.maps.Point(0, 0);
        var anchor = new google.maps.Point(54, 30);
    }
    else
    {
        var size = new google.maps.Size(45, 51);
        var origin = new google.maps.Point(0, 0);
        var anchor = new google.maps.Point(45, 26);
    }

    var icon = {
        url: marker,
        size: size,
        scaledSize: size,
        origin: origin,
        anchor: anchor,
    };

    var this_marker = new google.maps.Marker({
        position: point,
        map,
        title: title,
        icon: icon,
        location_id: location_id
    });

    this_marker.addListener("click", () => {
        setActiveLocation(this_marker.location_id);
      });

      markers[map_id].push(this_marker);

}

function addMapMarkers()
{
    const all_locations_lis = document.querySelectorAll("ul.locations_list > li");
    console.log(all_locations_lis);
    all_locations_lis.forEach(location_li => {
        if (location_li.dataset.latLong)
        {
            const [lat,lng] = location_li.dataset.latLong.split(/\s*,\s*/).map(Number);
            const id = location_li.getAttribute("data-id");
            const title = location_li.querySelector("h4").innerHTML;
            const marker_url = location_li.getAttribute("data-marker");
            if (!isNaN(lat) && !isNaN(lng))
            {
                addMarker(locations_map,[lat,lng],id,title,marker_url,"small");
            }
        }
        else
        {
            console.log("No lat long for location id "+location_li.getAttribute("data-id"));
        }

    });

    setTimeout(500,fitBounds(locations_map));
}

function fitBounds(map)
{

    var bounds = new google.maps.LatLngBounds();
    var map_id = map.getDiv().id;
    var map_points = points[map_id];

    for (var i = 0; i < map_points.length; i++)
    {
        bounds.extend(new google.maps.LatLng(map_points[i].lat, map_points[i].lng));
    }

    google.maps.event.addListenerOnce(map, 'bounds_changed', function(event)
    {
        if (this.getZoom() > default_zoom)
        {
            this.setZoom(default_zoom);
        }
    });

    map.fitBounds(bounds);

}

function setActiveLocation(location_id)
{
    markers[locations_map.getDiv().id].forEach(marker =>
    {
        if (marker.location_id == location_id)
        {
            locations_map.setZoom(default_zoom);
            locations_map.setCenter(marker.getPosition());
        } 
    });

    console.log(location_id);

    const all_locations_lis = document.querySelectorAll("ul.locations_list li");
    const location_li = document.querySelector(".locations_list li[data-id='"+location_id+"']");

    all_locations_lis.forEach(li => {
        if (li != location_li)
        {
            li.classList.remove("active");
        }
    });
    location_li.classList.add("active");

    setTimeout(() => {
        location_li.scrollIntoView({
            behavior: 'smooth', // smooth scrolling
            block: 'center',    // center it vertically in the viewport
            inline: 'nearest'
        });
    }, 300);



}


document.addEventListener("DOMContentLoaded", () => {
    initMap(document.querySelector('.locations_map'));

    const all_locations_lis = document.querySelectorAll("ul.locations_list li");
    all_locations_lis.forEach(location_li => {
        location_li.addEventListener("click", (e) => {
            const location_id = location_li.getAttribute("data-id");

            if (location_li.classList.contains("active"))
            {
                if (e.target.tagName.toLowerCase() === 'h4' || e.target.closest('h4'))
                {
                    location_li.classList.remove("active");
                    fitBounds(locations_map);
                }
            }
            else
            {
                setActiveLocation(location_id);
            }
        });
    });
});